import FirestoreDocument from "../../../types/FirestoreDocument";
import { string } from "../../../types/_types";

export const WorkRef = FirestoreDocument.extend({
	name: string(),
});
